/* Power of the Almond — LP2 landing page behaviour. No dependencies. */
(function () {
  'use strict';
  if (window.__lp2) return; window.__lp2 = true;
  var doc = document;
  var $ = function (s, r) { return (r || doc).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    fmt = fmt || '${{amount}}';
    return fmt.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }

  /* ---------- Reveal on scroll ---------- */
  function reveals() {
    var els = $$('.lp2-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        var sibs = e.target.parentElement ? $$(':scope > .lp2-reveal', e.target.parentElement) : [];
        var i = Math.max(0, sibs.indexOf(e.target));
        e.target.style.transitionDelay = Math.min(i, 6) * 70 + 'ms';
        e.target.classList.add('is-in'); io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Count-up (net-carb math) ---------- */
  function counters() {
    var eq = $('[data-eq]'); if (!eq) return;
    var nums = $$('[data-count]', eq);
    var run = function () {
      nums.forEach(function (b, idx) {
        var to = parseFloat(b.dataset.count) || 0, start = null, dur = 900, delay = idx * 380;
        if (reduce) { b.textContent = to; return; }
        setTimeout(function () {
          var step = function (t) { if (!start) start = t; var p = Math.min(1, (t - start) / dur); b.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(step); };
          requestAnimationFrame(step);
        }, delay);
      });
    };
    if (!('IntersectionObserver' in window)) return run();
    var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { run(); io.disconnect(); } }, { threshold: 0.4 });
    io.observe(eq);
  }

  /* ---------- Light parallax ---------- */
  function parallax() {
    var els = $$('[data-parallax]'); if (!els.length || reduce) return;
    var tick = false;
    var upd = function () {
      var vh = innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect(); if (r.bottom < -100 || r.top > vh + 100) return;
        var k = parseFloat(el.dataset.parallax) || 0; var c = r.top + r.height / 2 - vh / 2;
        el.style.translate = '0 ' + (c * k).toFixed(1) + 'px';
      });
      tick = false;
    };
    addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true });
    upd();
  }

  /* ---------- Review rail: drag + arrows ---------- */
  function rail() {
    var r = $('[data-rail]'); if (!r) return;
    var step = function () { var c = r.firstElementChild; return c ? c.getBoundingClientRect().width + 16 : 320; };
    var p = $('[data-rail-prev]'), n = $('[data-rail-next]');
    p && p.addEventListener('click', function () { r.scrollBy({ left: -step(), behavior: 'smooth' }); });
    n && n.addEventListener('click', function () { r.scrollBy({ left: step(), behavior: 'smooth' }); });
    var down = false, sx = 0, sl = 0, moved = false;
    r.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = false; sx = e.clientX; sl = r.scrollLeft; r.classList.add('is-drag'); });
    addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - sx; if (Math.abs(dx) > 4) moved = true; r.scrollLeft = sl - dx; });
    addEventListener('pointerup', function () { if (!down) return; down = false; r.classList.remove('is-drag'); });
    r.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }

  /* ---------- Loox widget collapse (its iframe can run ~6,000px on mobile) ---------- */
  function collapse() {
    $$('[data-collapse]').forEach(function (w) {
      var inner = w.firstElementChild, btn = $('[data-collapse-btn]', w);
      var check = function () { if (!w.dataset.open && inner.scrollHeight > 760) w.classList.add('is-collapsed'); };
      check(); setTimeout(check, 1500); setTimeout(check, 4000);
      if ('ResizeObserver' in window) new ResizeObserver(check).observe(inner);
      btn && btn.addEventListener('click', function () { w.dataset.open = '1'; w.classList.remove('is-collapsed'); });
    });
  }

  /* ---------- Founder video sound toggle ---------- */
  function sound() {
    $$('[data-sound-btn]').forEach(function (b) {
      var v = $('video', b.parentElement); if (!v) { b.hidden = true; return; }
      b.addEventListener('click', function () {
        v.muted = !v.muted; if (!v.muted) { v.currentTime = 0; v.play(); }
        b.setAttribute('aria-pressed', String(!v.muted));
        $('[data-sound-label]', b).textContent = v.muted ? 'Tap for sound' : 'Mute';
      });
    });
    // Pause off-screen videos to save data/battery
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { en.forEach(function (e) { var v = e.target; if (e.isIntersecting) { var p = v.play(); p && p.catch && p.catch(function () {}); } else v.pause(); }); }, { threshold: 0.1 });
      $$('video').forEach(function (v) { io.observe(v); });
    }
  }


  /* ---------- Video rows: tap for sound (one at a time) ---------- */
  function reels() {
    $$('[data-reel-snd]').forEach(function (b) {
      var v = $('video', b.parentElement); if (!v) { b.hidden = true; return; }
      b.addEventListener('click', function () {
        var on = v.muted;
        $$('[data-reel-snd]').forEach(function (o) { var ov = $('video', o.parentElement); if (ov && ov !== v) { ov.muted = true; o.setAttribute('aria-pressed', 'false'); $('[data-reel-lbl]', o).textContent = 'Tap for sound'; o.parentElement.classList.remove('is-live'); } });
        v.muted = !on; if (on) { v.currentTime = 0; v.loop = false; v.volume = 1; } else { v.loop = true; }
        var p = v.play(); p && p.catch && p.catch(function () { v.muted = true; v.loop = true; v.play().catch(function () {}); b.setAttribute('aria-pressed', 'false'); $('[data-reel-lbl]', b).textContent = 'Tap for sound'; b.parentElement.classList.remove('is-live'); });
        b.setAttribute('aria-pressed', String(on)); $('[data-reel-lbl]', b).textContent = on ? 'Mute' : 'Tap for sound';
        b.parentElement.classList.toggle('is-live', on);
      });
      v.addEventListener('ended', function () { v.muted = true; v.loop = true; v.play().catch(function () {}); b.setAttribute('aria-pressed', 'false'); $('[data-reel-lbl]', b).textContent = 'Tap for sound'; b.parentElement.classList.remove('is-live'); });
    });
  }

  /* ---------- Pop-up video player (data-lp2-play="mp4 url") ---------- */
  function player() {
    var dlg;
    doc.addEventListener('click', function (e) {
      var t = e.target.closest('[data-lp2-play]'); if (!t) return;
      e.preventDefault();
      if (!dlg) {
        dlg = doc.createElement('dialog'); dlg.className = 'lp2-vp'; dlg.setAttribute('aria-label', 'Video');
        dlg.innerHTML = '<div class="lp2-vp__in"><button type="button" class="lp2-vp__x" aria-label="Close video">&times;</button><video class="lp2-vp__v" playsinline controls></video></div>';
        doc.body.appendChild(dlg);
        var shut = function () { var v = $('video', dlg); v.pause(); if (dlg.open) dlg.close(); };
        $('.lp2-vp__x', dlg).addEventListener('click', shut);
        dlg.addEventListener('click', function (ev) { if (ev.target === dlg) shut(); });
        dlg.addEventListener('close', function () { $('video', dlg).pause(); });
      }
      var v = $('video', dlg);
      v.src = t.getAttribute('data-lp2-play'); if (t.dataset.poster) v.poster = t.dataset.poster;
      v.setAttribute('aria-label', t.dataset.title || 'Video');
      dlg.showModal(); v.muted = false; v.currentTime = 0;
      var p = v.play(); p && p.catch && p.catch(function () { v.muted = true; v.play().catch(function () {}); });
    });
  }

  /* ---------- Cart helpers ---------- */
  function cartCount() {
    var bump = function () { $$('[data-lp2-cart]').forEach(function (b) { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); }); };
    if (window.LP2Cart) { window.LP2Cart.refresh().then(bump); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
      doc.documentElement.classList.toggle('lp2-has-items', c.item_count > 0);
      $$('[data-lp2-count]').forEach(function (el) { el.textContent = c.item_count; el.hidden = !c.item_count; });
      bump();
    }).catch(function () {});
  }
  // Keep cart counts in sync whenever the cart changes
  (function watchCart() {
    if (!window.fetch) return;
    var f = window.fetch, t;
    window.fetch = function (u) {
      var p = f.apply(this, arguments), url = String((u && u.url) || u || '');
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { clearTimeout(t); t = setTimeout(function () { cartCount(); doc.dispatchEvent(new CustomEvent('lp2:cart-changed')); }, 250); }).catch(function () {});
      return p;
    };
  })();
  function openCart() {
    if (window.LP2Cart) { window.LP2Cart.open(true); return true; }
    return false;
  }
  function headerCart() {
    $$('[data-lp2-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) { if (openCart()) { e.preventDefault(); e.stopPropagation(); } }, true);
    });
  }

  /* ---------- Box builder ---------- */
  function builder() {
    var root = $('[data-lp2-builder]'); if (!root) return;
    var cfg; try { cfg = JSON.parse($('[data-lp2-config]', root).textContent); } catch (e) { return; }
    var byId = {}; cfg.variants.forEach(function (v) { byId[v.id] = v; });
    var cards = $$('[data-flav]', root);
    cards.forEach(function (c) { var v = byId[c.dataset.flav]; var im = $('img', c); if (v && im) v.thumb = im.currentSrc || im.src; });

    var state = { size: cfg.boxSize, slots: [], active: -1, cookie: null, freq: 'once', qty: 1 };
    // Box always starts empty (no preset) so it never looks like choices the shopper already made.
    // Cart awareness: loaves already in the cart from other pages count toward Buy 3.
    var QUAL = cfg.qualHandles || ['low-carb-lemon-pound-cake', 'banana-pudding-keto-pound-cake-loaf', 'first-taste-of-fall-low-carb-lifestyle-pound-cake', 'october-bakehouse-collection', 'southern-thanksgiving-collection'];
    var cookieIds = $$('.lp2-cookie', root).map(function (b) { return String(b.dataset.cookie); }).filter(function (x) { return x && x !== 'none'; });
    var cart = { loaves: 0, rem: 0, cookie: false, cookieName: '', cookiePrice: 0, lines: [], items: [] };
    var ck = $('.lp2-cookie[aria-checked="true"]', root); state.cookie = ck ? ck.dataset.cookie : 'none';

    var slotsEl = $('[data-slots]', root), boxEl = $('[data-box]', root);
    var addBtn = $('[data-add]', root), errEl = $('[data-error]', root), hint = $('[data-hint]', root);
    var dock = $('[data-dock]', root), dockBtn = $('[data-dock-btn]', root);

    function need() { return cfg.boxSize - cart.rem; }
    function completing() { return cart.rem > 0; }
    function full() { return state.slots.length >= state.size; }
    function qualifies() { return state.size + cart.rem >= cfg.boxSize; }
    function cookieOn() { return qualifies() && !(completing() && cart.cookie) && state.cookie && state.cookie !== 'none'; }
    function single() { return state.size < need(); }
    function shortName(t) { return String(t || '').replace(/ Pound Cake$/i, '').replace(/^Low Carb Lifestyle Pound Cake - No Sugar Added Gluten-Free$/i, 'Lifestyle Pound Cake'); }
    function applyCart(c) {
      var loaves = 0, lines = {}, order = [], items = [], ck = false, ckName = '', ckPrice = 0;
      (c.items || []).forEach(function (it) {
        if (QUAL.indexOf(it.handle) >= 0) {
          loaves += it.quantity;
          var nm = shortName(it.variant_title || it.product_title);
          if (!lines[nm]) { lines[nm] = 0; order.push(nm); } lines[nm] += it.quantity;
          for (var q = 0; q < it.quantity; q++) items.push({ name: nm, price: it.original_price || it.price || 0, img: it.image ? (/^(https?:)?\/\//.test(it.image) ? it.image + (it.image.indexOf('?') >= 0 ? '&' : '?') + 'width=160' : it.image) : '' });
        } else if (cookieIds.indexOf(String(it.variant_id)) >= 0 || /cookie/i.test(it.handle || '')) { if (!ck) { ckName = String(it.product_title || '').replace(/^(Free )?(Low Carb )?(Lifestyle )?(Keto )?/i, ''); ckPrice = it.original_price || it.price || 0; } ck = true; }
      });
      var prevRem = cart.rem;
      cart = { loaves: loaves, rem: loaves % cfg.boxSize, cookie: ck, cookieName: ckName, cookiePrice: ckPrice, lines: order.map(function (n) { return (lines[n] > 1 ? lines[n] + ' ' : '') + n; }), items: items.slice(items.length - (loaves % cfg.boxSize)) };
      if (cart.rem !== prevRem) {
        state.size = completing() ? need() : cfg.boxSize;
        state.slots = state.slots.slice(0, state.size); state.active = -1; state.mem = null;
        if (completing()) state.freq = 'once';
      }
      render();
    }
    function syncCart() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(applyCart).catch(function () {});
    }
    var incart = doc.createElement('div'); incart.className = 'lp2-incart'; incart.hidden = true; incart.setAttribute('data-incart', '');
    boxEl.parentNode.insertBefore(incart, boxEl);
    incart.addEventListener('click', function (e) { var a = e.target.closest('[data-incart-view]'); if (a && openCart()) e.preventDefault(); });
    function seasonalIn() { return state.slots.filter(function (id) { return byId[id] && byId[id].seasonal; }); }
    function canSub() { return !!cfg.planId && single() && seasonalIn().length === 0; }
    function sub() { return state.freq === 'sub' && canSub(); }
    function base() { return state.slots.reduce(function (s, id) { return s + byId[id].price; }, 0); }
    function subPrice() { return state.slots.reduce(function (s, id) { return s + Math.round(byId[id].price * (1 - cfg.planPct / 100)); }, 0); }
    function fullBase() { var p = cfg.variants[0] ? cfg.variants[0].price : 0; return p * state.size; }

    function renderSlots(popIdx) {
      var lockN = completing() ? cart.rem : 0;
      boxEl.dataset.n = state.size + lockN;
      slotsEl.style.setProperty('--n', state.size + lockN);
      var html = '';
      cart.items.slice(0, lockN).forEach(function (it) {
        html += '<div class="lp2-slot is-filled is-incart" aria-label="' + it.name + ', already in your cart">' +
          (it.img ? '<img src="' + it.img + '" alt="" width="80" height="80">' : '') +
          '<span class="lp2-slot__name">' + it.name + '</span><span class="lp2-slot__tag">In cart</span></div>';
      });
      for (var i = 0; i < state.size; i++) {
        var id = state.slots[i];
        if (id) {
          var v = byId[id];
          html += '<div class="lp2-slot is-filled' + (i === state.active ? ' is-active' : '') + (i === popIdx ? ' is-pop' : '') + '" data-slot="' + i + '" role="button" tabindex="0" aria-label="' + v.title + ' in slot ' + (i + 1) + '. Tap to swap.">' +
            '<img src="' + (v.thumb || v.img) + '" alt="" width="80" height="80">' +
            '<span class="lp2-slot__name">' + v.title + '</span>' +
            '<button type="button" class="lp2-slot__x" data-remove="' + i + '" aria-label="Remove ' + v.title + '">&times;</button></div>';
        } else {
          html += '<div class="lp2-slot" data-slot="' + i + '"><span class="lp2-slot__plus" aria-hidden="true">+</span><span>Loaf ' + (i + 1 + lockN) + '</span></div>';
        }
      }
      slotsEl.innerHTML = html;
    }

    function render(popIdx) {
      renderSlots(popIdx);
      var n = state.slots.length, left = state.size - n;
      $('[data-box-title]', root).textContent = completing() && !single() ? 'Finish your ' + cfg.boxSize + '-loaf box' : (state.size === 1 ? 'Your loaf' : (single() ? 'Your ' + state.size + ' loaves' : 'Your ' + state.size + '-loaf box'));
      $('[data-box-count]', root).textContent = completing() && !single() ? (n + cart.rem) + ' / ' + cfg.boxSize : (state.size === 1 ? '' : n + ' / ' + state.size);
      var sz = $('.lp2-size', root); if (sz) sz.hidden = completing();
      root.classList.toggle('is-completing', completing());
      if (cart.loaves > 0) {
        incart.hidden = false;
        incart.innerHTML = '<span><b>In your cart:</b> ' + cart.lines.join(', ') + '.</span> ' +
          (completing() ? '<span>' + (left > 0 ? 'Pick ' + left + ' more to finish your box and unlock free cookies + shipping.' : 'Your box is complete.') + '</span> ' : '<span>Build another box below.</span> ') +
          '<a href="/cart" data-incart-view>View cart</a>';
      } else { incart.hidden = true; incart.innerHTML = ''; }
      var qw = $('[data-qty-wrap]', root); if (qw) qw.hidden = !single();
      $$('[data-qty]', root).forEach(function (b) { b.setAttribute('aria-checked', String(+b.dataset.qty === state.size)); });
      $$('[data-size]', root).forEach(function (b) { b.setAttribute('aria-checked', String(+b.dataset.size === cfg.boxSize ? !single() : single())); });

      // bonus row
      var bonus = $('[data-bonus]', root), bt = $('[data-bonus-text]', root);
      bonus.hidden = !qualifies();
      var cName = cookieOn() ? $('.lp2-cookie[data-cookie="' + state.cookie + '"]', root).dataset.cookieName : '';
      if (full() && completing() && cart.cookie) { bonus.classList.add('is-on'); bt.textContent = 'Free shipping unlocked · the cookies in your cart become free'; }
      else if (full() && cookieOn()) { bonus.classList.add('is-on'); bt.textContent = 'Free ' + cName + ' + free shipping unlocked'; }
      else if (full()) { bonus.classList.add('is-on'); bt.textContent = 'Free shipping unlocked'; }
      else { bonus.classList.remove('is-on'); bt.textContent = 'Add ' + left + ' more to unlock free cookies + shipping'; }

      // shelf state
      root.classList.toggle('is-single', state.size === 1);
      root.classList.toggle('is-full', full());
      cards.forEach(function (c) {
        var id = +c.dataset.flav, k = state.slots.filter(function (x) { return x === id; }).length;
        c.classList.toggle('is-in', k > 0);
        var nb = $('[data-flav-n]', c); if (nb) nb.textContent = state.size === 1 ? '✓' : String(k);
        var qa = $('[data-quick-add]', c); if (qa) qa.setAttribute('aria-label', (full() ? 'Swap in ' : 'Add ') + byId[id].title);
        var pl = $('[data-step-plus]', c); if (pl) { pl.disabled = false; pl.setAttribute('aria-label', (full() ? 'Swap in ' : 'Add ') + byId[id].title); }
        var hit = $('[data-flav-add]', c);
        if (hit) hit.setAttribute('aria-label', byId[id].title + (k ? ', ' + k + ' in box' : '') + '. See ingredients and nutrition.');
      });
      $('[data-shelf-label]', root).textContent = full() ? (state.size === 1 ? 'Tap a flavor to see it, or (+) to switch' : 'Box full · (+) swaps out ' + (state.active >= 0 ? 'the highlighted loaf' : 'the last loaf') + ', or tap a loaf in your box to pick which one') : 'Tap a flavor to see ingredients · (+) adds it (' + left + ' to go)';
      hint.textContent = full() && state.size > 1 ? 'Tap any loaf to choose which one to swap' : '';

      // cookies
      var cw = $('[data-cookies]', root); if (cw) cw.hidden = !qualifies() || (completing() && cart.cookie);
      $$('.lp2-cookie', root).forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.cookie === String(state.cookie))); });
      var cab = $('[data-cookie-about]', root);
      if (cab) { var anyAb = false; $$('[data-about]', cab).forEach(function (p) { var on = p.dataset.about === String(state.cookie); p.hidden = !on; if (on) anyAb = true; }); cab.hidden = !anyAb; }

      // purchase option: subscribe only on a single year-round loaf
      var fw = $('[data-freq-wrap]', root), lock = $('[data-sub-lock]', root);
      var seas = seasonalIn(), subBtn = $('[data-freq="sub"]', root);
      if (!canSub() && state.freq === 'sub') state.freq = 'once';
      if (fw) fw.hidden = !(cfg.planId && single());
      if (subBtn) { subBtn.setAttribute('aria-disabled', String(!canSub())); subBtn.classList.toggle('is-locked', !canSub()); }
      if (lock) {
        var showLock = single() && seas.length > 0 && !!cfg.planId;
        lock.hidden = !showLock;
        if (showLock) lock.textContent = (cfg.lockMsg || '[flavor] is a seasonal flavor.').replace('[flavor]', seas.map(function (id) { return byId[id].title; }).join(' and '));
      }

      // freq + prices
      var once = base(), sp = subPrice();
      var po = $('[data-p-once]', root), ps = $('[data-p-sub]', root), pw = $('[data-p-was]', root);
      var showBase = n ? once : fullBase(), showSub = n ? sp : Math.round(fullBase() * (1 - cfg.planPct / 100));
      if (po) po.textContent = money(showBase, cfg.money);
      if (ps) ps.textContent = money(showSub, cfg.money);
      if (pw) pw.textContent = money(showBase, cfg.money);
      $$('[data-freq]', root).forEach(function (b) { b.setAttribute('aria-checked', String(b.dataset.freq === state.freq)); });
      var pol = $('[data-sub-policy]', root); if (pol) pol.hidden = !sub();
      var st = $('[data-sub-terms]', root); if (st) st.textContent = (cfg.subTerms || '').replace('[price]', money(showSub, cfg.money));

      // summary
      var price = sub() ? sp : once;
      var order = [], cnt = {};
      state.slots.forEach(function (id) { if (!cnt[id]) { cnt[id] = 0; order.push(id); } cnt[id]++; });
      var lines = order.map(function (id) {
        var v = byId[id], each = sub() ? Math.round(v.price * (1 - cfg.planPct / 100)) : v.price;
        return '<div><dt>' + v.title + (cnt[id] > 1 ? ' <span class="lp2-sum__x">×' + cnt[id] + '</span>' : '') + '</dt><dd>' + money(each * cnt[id], cfg.money) + '</dd></div>';
      });
      var lockItems = completing() ? cart.items.slice(0, cart.rem) : [], cartPrice = 0, lc = {}, lo = [];
      lockItems.forEach(function (it) { cartPrice += it.price; if (!lc[it.name]) { lc[it.name] = { n: 0, p: 0 }; lo.push(it.name); } lc[it.name].n++; lc[it.name].p += it.price; });
      if (lo.length) lines = lo.map(function (nm) { return '<div class="lp2-sum__incart"><dt>' + nm + (lc[nm].n > 1 ? ' <span class="lp2-sum__x">×' + lc[nm].n + '</span>' : '') + ' <span class="lp2-slot__tag">In cart</span></dt><dd>' + money(lc[nm].p, cfg.money) + '</dd></div>'; }).concat(lines);
      if (left > 0) lines.push('<div class="lp2-sum__todo"><dt>' + left + ' more loa' + (left === 1 ? 'f' : 'ves') + ' to pick</dt><dd></dd></div>');
      if (sub() && n) lines.push('<div class="lp2-sum__plan"><dt>Delivered monthly</dt><dd></dd></div>');
      $('[data-sum-lines]', root).innerHTML = lines.join('');
      var sc = $('[data-sum-cookie]', root), cPrice = cookieOn() ? parseInt($('.lp2-cookie[data-cookie="' + state.cookie + '"]', root).dataset.cookiePrice || 0, 10) : 0;
      var cartCk = completing() && cart.cookie && qualifies();
      if (cartCk) cPrice = cart.cookiePrice;
      sc.hidden = !(full() && (cookieOn() || cartCk));
      if (cartCk) { $('dt', sc).innerHTML = (cart.cookieName || 'Cookies') + ' <span class="lp2-slot__tag">In cart</span>'; $('[data-sum-cookie-was]', sc).textContent = money(cPrice, cfg.money); }
      else if (cookieOn()) { $('dt', sc).textContent = cName; $('[data-sum-cookie-was]', sc).textContent = money(cPrice, cfg.money); }
      var shipOn = full() && qualifies();
      $('[data-sum-ship]', root).hidden = !shipOn;
      var extra = (full() && (cookieOn() || cartCk) ? cPrice : 0) + (shipOn ? (cfg.shipCents || 0) : 0);
      var boxTotal = price + cartPrice;
      var was = $('[data-sum-was]', root); was.textContent = extra ? money(boxTotal + extra, cfg.money) : '';
      var stEl = $('[data-sum-total]', root); stEl.setAttribute('data-new-cents', String(price)); stEl.textContent = money(boxTotal, cfg.money);
      var tl = $('[data-sum-total-l]', root); if (tl) tl.textContent = completing() && !single() ? 'Box total' : (single() ? 'Subtotal' : 'Total');
      var ex = $('[data-sum-extras]', root);
      if (ex) { ex.hidden = !extra; $('[data-sum-extras-t]', root).textContent = extra ? 'You get ' + money(extra, cfg.money) + ' ' + (cfg.extrasLabel || 'in freebies & savings') + '. ' + (cfg.freezeNote || '') : ''; }

      // CTA
      var label = full() ? (state.size === 1 ? 'Add loaf to cart' : (single() ? 'Add ' + state.size + ' loaves to cart' : 'Add box to cart')) : 'Pick ' + left + ' more loa' + (left === 1 ? 'f' : 'ves');
      $('[data-add-label]', root).textContent = label;
      addBtn.dataset.ready = full() ? '1' : '0';
      // dock
      $('[data-dock-title]', root).textContent = completing() && !single() ? 'Finish your box' : (n === 0 && !single() ? 'Build your box' : (state.size === 1 ? '1 loaf' : (single() ? state.size + ' loaves' : state.size + '-loaf box')));
      $('[data-dock-meta]', root).textContent = full() ? (completing() && !single() ? 'Box total ' + money(price + (completing() ? cart.items.slice(0, cart.rem).reduce(function (a, it) { return a + it.price; }, 0) : 0), cfg.money) + ' · free shipping + cookies' : money(price, cfg.money) + (qualifies() ? ' · free shipping + cookies' : '')) :
        (completing() && !single() ? cart.rem + ' in cart · pick ' + left + ' more' : (n === 0 ? 'Pick ' + left + ' loa' + (left === 1 ? 'f' : 'ves') + (qualifies() ? ' · free shipping + cookies' : '') : left + ' more to go'));
      dockBtn.textContent = full() ? 'Add to cart' : (n === 0 ? 'Pick flavors' : 'Finish box');
      errEl.textContent = '';
    }

    function fly(fromImg, slotIdx) {
      if (reduce || !fromImg) return;
      var target = $('[data-slot="' + slotIdx + '"] img', slotsEl); if (!target) return;
      var a = fromImg.getBoundingClientRect(), b = target.getBoundingClientRect();
      if (b.bottom < 0 || b.top > innerHeight) return; // box not visible, skip
      var f = doc.createElement('img'); f.src = fromImg.currentSrc || fromImg.src; f.className = 'lp2-fly'; f.alt = '';
      var s = Math.min(a.width, 120);
      f.style.cssText = 'left:' + (a.left + a.width / 2 - s / 2) + 'px;top:' + (a.top + a.height / 2 - s / 2) + 'px;width:' + s + 'px;height:' + s + 'px';
      doc.body.appendChild(f);
      target.style.opacity = '0';
      requestAnimationFrame(function () {
        var dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + b.height / 2 - (a.top + a.height / 2);
        f.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(' + (b.width / s) + ')';
      });
      setTimeout(function () { target.style.opacity = ''; f.remove(); }, 560);
    }

    function addFlavor(id, card) {
      var idx;
      if (!full()) { state.slots.push(id); idx = state.slots.length - 1; state.active = -1; }
      else {
        idx = state.active >= 0 ? state.active : state.size - 1;
        state.slots[idx] = id; state.active = -1;
      }
      render(idx);
      fly(card && $('img', card), idx);
      if (full() && window.innerWidth < 990) {
        // nudge toward checkout on mobile once the box is complete
        hint.textContent = state.size > 1 ? 'Box complete. Tap any loaf to swap it.' : '';
      }
    }

    function removeOne(id) {
      var i = state.slots.lastIndexOf(id); if (i < 0) return;
      state.slots.splice(i, 1); state.active = -1; render();
    }
    cards.forEach(function (c) {
      var id = +c.dataset.flav, hit = $('[data-flav-add]', c);
      if (hit) hit.addEventListener('click', function () { if (window.LP2Inside) window.LP2Inside.openSheet(id); else if (!hit.disabled) addFlavor(id, c); });
      var qa = $('[data-quick-add]', c);
      if (qa) qa.addEventListener('click', function (e) { e.stopPropagation(); if (!qa.disabled) addFlavor(id, c); });
      var mi = $('[data-step-minus]', c), pl = $('[data-step-plus]', c);
      if (mi) mi.addEventListener('click', function (e) { e.stopPropagation(); removeOne(id); });
      if (pl) pl.addEventListener('click', function (e) { e.stopPropagation(); addFlavor(id, c); });
    });
    slotsEl.addEventListener('click', function (e) {
      var x = e.target.closest('[data-remove]');
      if (x) { e.stopPropagation(); state.slots.splice(+x.dataset.remove, 1); state.active = -1; render(); return; }
      var s = e.target.closest('.lp2-slot.is-filled');
      if (s) { var i = +s.dataset.slot; state.active = state.active === i ? -1 : i; render(); }
    });
    slotsEl.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target.classList.contains('lp2-slot')) { e.preventDefault(); e.target.click(); } });

    function setSize(n) {
      if (n === state.size) return;
      if (state.slots.length > (state.mem || []).length || n < state.slots.length) state.mem = state.slots.slice();
      state.size = n; state.slots = state.slots.slice(0, n); state.active = -1;
      (state.mem || []).forEach(function (id, i) { if (state.slots.length < n && i >= state.slots.length) state.slots.push(id); });
      if (!single()) state.freq = 'once';
      render();
    }
    $$('[data-size]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var n = +b.dataset.size;
        if (n < cfg.boxSize) { if (single()) return; n = state.qty || 1; } else n = need();
        setSize(n);
      });
    });
    $$('[data-qty]', root).forEach(function (b) { b.addEventListener('click', function () { state.qty = +b.dataset.qty; setSize(state.qty); }); });
    window.LP2Builder = {
      add: function (id) { var c = $('[data-flav="' + id + '"]', root); addFlavor(+id, c); },
      label: function (id) { var k = state.slots.filter(function (x) { return x === +id; }).length; return full() ? (state.size === 1 ? 'Choose this loaf' : 'Swap into my box') : (k ? 'Add another to my box' : (state.size === 1 ? 'Choose this loaf' : 'Add to my box')); }
    };
    $$('.lp2-cookie', root).forEach(function (b) { b.addEventListener('click', function () { state.cookie = b.dataset.cookie; render(); }); });
    function ckClose(d) { if (d.close) d.close(); else d.removeAttribute('open'); document.documentElement.classList.remove('lp2-lock'); }
    $$('[data-ck-sheet]', root).forEach(function (d) {
      if (d.parentNode !== document.body) document.body.appendChild(d);
      d.addEventListener('click', function (e) {
        if (e.target === d || e.target.closest('[data-ck-close]')) { ckClose(d); return; }
        var pk = e.target.closest('[data-ck-pick]'); if (pk) { state.cookie = pk.dataset.ckPick; render(); ckClose(d); }
      });
      d.addEventListener('close', function () { document.documentElement.classList.remove('lp2-lock'); });
    });
    $$('[data-cookie-info]', root).forEach(function (b) { b.addEventListener('click', function (e) {
      e.preventDefault(); var d = document.querySelector('[data-ck-sheet="' + b.dataset.cookieInfo + '"]'); if (!d) return;
      document.documentElement.classList.add('lp2-lock'); if (d.showModal) d.showModal(); else d.setAttribute('open', '');
      var inn = d.querySelector('.lp2-sheet__in'); if (inn) inn.scrollTop = 0;
    }); });
    $$('[data-freq]', root).forEach(function (b) { b.addEventListener('click', function () {
      if (b.dataset.freq === 'sub' && !canSub()) { var l = $('[data-sub-lock]', root); if (l && !l.hidden) { l.classList.remove('is-nudge'); void l.offsetWidth; l.classList.add('is-nudge'); } return; }
      state.freq = b.dataset.freq; render(); }); });

    function submit() {
      if (!full()) {
        errEl.textContent = '';
        var shelf = $('[data-shelf]', root); shelf && shelf.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        return;
      }
      var counts = {}; state.slots.forEach(function (id) { counts[id] = (counts[id] || 0) + 1; });
      var items = Object.keys(counts).map(function (id) {
        var it = { id: +id, quantity: counts[id], properties: { _source: cfg.source } };
        if (sub()) it.selling_plan = cfg.planId; return it;
      });
      if (cookieOn() && full()) items.push({ id: +state.cookie, quantity: 1, properties: { _source: cfg.source + '-free-cookie' } });
      addBtn.classList.add('is-busy'); dockBtn.disabled = true;
      var lbl = $('[data-add-label]', root), prev = lbl.textContent; lbl.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          lbl.textContent = 'Added ✓'; cartCount();
          setTimeout(function () { if (!openCart()) location.href = '/cart'; }, 250);
          setTimeout(function () { state.slots = []; state.active = -1; state.mem = null; syncCart(); }, 1600);
        })
        .catch(function (err) { lbl.textContent = prev; errEl.textContent = (err && (err.description || err.message)) || 'Something went wrong. Please try again.'; })
        .then(function () { addBtn.classList.remove('is-busy'); dockBtn.disabled = false; });
    }
    addBtn.addEventListener('click', submit);
    dockBtn.addEventListener('click', function () {
      if (full()) submit(); else { var b = $('[data-box]', root); b.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); }
    });

    // Hero CTA / any #box link: smooth scroll accounting for sticky header
    $$('a[href="#box"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var hdr = $('[data-lp2-header]'); var off = hdr ? hdr.offsetHeight + 8 : 0;
        var y = root.getBoundingClientRect().top + scrollY - off + (innerWidth < 990 ? 0 : 0);
        scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    // Dock: show when neither the hero CTA nor the builder's add button is on screen
    if ('IntersectionObserver' in window && dock) {
      var vis = { hero: true, add: false, build: false };
      var upd = function () { var on = !vis.hero && !vis.add && !vis.build; dock.classList.toggle('is-on', on); dock.setAttribute('aria-hidden', String(!on)); dockBtn.tabIndex = on ? 0 : -1; };
      var heroCta = $('[data-lp2-cta-hero]');
      var watch = function (el, key, th) { if (!el) return; new IntersectionObserver(function (en) { vis[key] = en[0].isIntersecting; upd(); }, { threshold: th || 0 }).observe(el); };
      watch(heroCta, 'hero'); watch(addBtn, 'add'); watch($('[data-shelf]', root), 'build', 0.15);
    }

    render();
    syncCart();
    doc.addEventListener('lp2:cart-changed', syncCart);
    addEventListener('pageshow', function (e) { if (e.persisted) syncCart(); });
  }

  function init() {
    doc.documentElement.classList.remove('no-js');
    var hdr = $('[data-lp2-header]');
    var setH = function () { if (hdr) doc.documentElement.style.setProperty('--hdr', hdr.offsetHeight + 'px'); };
    setH(); addEventListener('resize', setH);
    reveals(); counters(); parallax(); rail(); collapse(); sound(); reels(); player(); headerCart(); builder();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', function () { reveals(); counters(); });
})();

/* Mobile: stop the sticky box once the shelf has scrolled past, so it never covers checkout options */
(function () {
  var box = document.querySelector('.lp2-box'), shelf = document.querySelector('.lp2-build__shelf');
  if (!box || !shelf) return;
  var mq = window.matchMedia('(max-width:989px)'), tick = false;
  function check() {
    tick = false;
    if (!mq.matches) { box.classList.remove('is-parked'); return; }
    var top = parseFloat(getComputedStyle(box).top) || 90;
    box.classList.toggle('is-parked', shelf.getBoundingClientRect().bottom < top + box.offsetHeight + 16);
  }
  window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(check); } }, { passive: true });
  window.addEventListener('resize', check); check();
})();
